import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { fetchEnhancedSalesOrderUiEnabled } from '@/api/org/config/useEnhancedSalesOrderUi';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

// Discounts v2 group review at the unversioned path. Its components
// intentionally stay in ../../discounts-v2/ (folder not renamed to avoid
// churn).
const GroupReviewView = lazyRouteComponent(
  () => import('../../discounts-v2/GroupReviewView'),
  'GroupReviewView',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/discounts/$groupId',
  component: GroupReviewView,
  loader: () => ({
    crumb: 'Discount Group',
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
    // TEMPORARY redirect — remove after all tenants migrate to OMS v3.
    // Discounts v1 has no group detail page, so legacy orgs land on the list.
    if (!(await fetchEnhancedSalesOrderUiEnabled(context.queryClient))) {
      throw redirect({ to: '/discounts-v1' });
    }
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.DiscountV2,
    });
  },
});
